import { IOfferCard } from '../../../../types';
import { prepareAgentInfo } from './prepareAgentInfo';

export const prepareLabels = (offerCard: IOfferCard) => {
  const { offerUser } = offerCard;

  return {
    agentInfo: prepareAgentInfo(offerCard),
    isIdentifiedByDocument: !!offerUser?.agentModerationInfo?.showUserIdentifiedByDocuments,
  };
};
